<template>
  <div class = "Verify-wrapper">
    <el-container>
      <el-header class="Verify_header">
        <p>一网通办校外用户办事入口</p>
      </el-header>
      <el-main>
        <div id = "Verify">
          <el-form ref="VerifyForm" :model="VerifyForm" label-width="0" class="demoVerifyForm" :rules="verifyRules">
            <el-form-item class = "logoStyle">
              <img src="../assets/img/qlu_logo.png">
            </el-form-item>
            <el-form-item prop="tel" >
              <el-input placeholder="手机号" v-model="VerifyForm.tel" name = "tel">
              </el-input>
            </el-form-item>
            <el-form-item class="code" prop="code">
              <el-input v-model="VerifyForm.code" placeholder="验证码" name = "code"></el-input>
              <button class="buttenStyle" :disabled='isDisabled' @click.prevent="sendCode('VerifyForm')">{{buttonText}}</button>
            </el-form-item>
            <el-form-item>
              <button class="buttenStyle" @click.prevent="onVerify('VerifyForm')" style="width: 100%">登录</button>
            </el-form-item>
          </el-form>
        </div>
      </el-main>
      <div class="Verify_footer">
        Copyright@齐鲁工业大学（山东省科学院）
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    let checkTel = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'))
      } else if (!this.checkMobile(value)) {
        callback(new Error('手机号码不合法'))
      } else {
        callback();
      }
    }
    let checkCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机验证码'))
      } else {
        callback();
      }
    }
    return {
      VerifyForm: {
        tel: "",
        code: "",
        lcname: "",
      },
      keyState: {
        id:"",
        state: 0,
        created_time:0,
        tel:0,
        vercode:0,
      },
      verifyRules: {
        tel: [{ validator: checkTel, trigger: ['blur']}],
        code: [{ validator: checkCode, trigger: ['blur','change'] }]
      },
      buttonText: '发送验证码',
      isDisabled: false,
      flag: true,
      isFailure: true,
      timer: "",
      SQName:""
    }
  },
  created(){
    this.getSession();
  },
  methods: {
    getSession(){
      this.SQName = sessionStorage.getItem("SQName");
      this.VerifyForm.lcname = this.SQName;
    },

    onVerify(form) {
      this.$refs[form].validate(async valid => {
        if (!valid) return;

        const { data: res } = await this.$http.post("login", {
          tel: this.VerifyForm.tel,
          code: this.VerifyForm.code,
          lcname: this.VerifyForm.lcname
        });

        if (res.flag == "ok") {
          clearInterval(this.timer);
          sessionStorage.setItem("user", JSON.stringify(this.VerifyForm.tel));
          sessionStorage.setItem("login_token", res.token); // 存储加密 token

          this.$message.success("登录成功");
          this.$router.push(this.SQName); // 直接跳转到业务页
        } else {
          this.$message.error(res.message || "操作失败");
        }
      });
    },

    sendCode(form) {
      this.$refs[form].validateField('tel', async valid => {
        if (valid.length > 0) return;
        if (this.keyState.id != "") {
          clearInterval(this.timer);
          this.overState(this.keyState.id, -1);
        }
        let time = 60;
        let bigtime = 300;
        const { data: res } = await this.$http.post("createvercode", this.VerifyForm);

        if (res.flag == "ok") {
          this.buttonText = '已发送';
          this.isDisabled = true;
          this.keyState.id = res.key;
          this.keyState.created_time = res.created_time;
          this.keyState.tel = res.tel;

          if (this.flag) {
            this.flag = false;
            this.timer = setInterval(() => {
              bigtime--;
              time--;
              this.buttonText = time + 's';
              if (time === 0 && this.isFailure) {
                clearInterval(this.timer);
                this.buttonText = '重新获取';
                this.isDisabled = false;
                this.flag = true;
              }
              if (bigtime === 0 && this.isFailure) {
                clearInterval(this.timer);
                this.overState(res.key, -1);
              }
            }, 1000);
          }
        } else if (res.flag == "ismax") {
          this.$message.error("超过验证码申请数量，请明日再试");
        } else {
          this.$message.error("发送失败");
        }
      });
    },

    checkMobile(str) {
      let re = /^1\d{10}$/;
      return re.test(str);
    },

    async overState(key, state) {
      this.keyState.id = key;
      this.keyState.state = state;
      const { data: res } = await this.$http.post("overstate", this.keyState);
      return res == "ok" ? 1 : 0;
    }
  }
}
</script>

<style scoped>
.Verify-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
#Verify {
  max-width: 340px;
  margin: 60px auto;
  background: #fff;
  padding: 20px 40px;
  border-radius: 10px;
  position: relative;
  z-index: 9;
}
.el-form-item {
  text-align: center;
}
.code >>> .el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.code button {
  margin-left: 20px;
  width: 140px;
  text-align: center;
}
.Verify_header{
  background-color: #004387;
  text-align: center;
  color: #ffffff;
  font-size: 120%;
}
.Verify_footer{
  background-color: #004387;
  color: #ffffff;
  text-align: center;
  font-size: 75%;
  position:fixed;
  bottom:0;
  width: 100%;
  height: 20px;
  margin: 0px;
}
.buttenStyle{
  color: #ffffff;
  background-color: #004387;
  border: 1px solid #fff;
  border-radius: 4px;
  height: 40px;
  width: 100%;
}
.buttenStyle:hover{
  background-color: #fff;
  color: #004387;
  border:1px solid #004387;
}
.logoStyle{
  width: 100%;
}
.logoStyle img{
  width: 100%;
}
</style>